"use client"

import {
  LineChart, Line, BarChart, Bar, AreaChart, Area, ResponsiveContainer,
} from "recharts"
import type { CSSProperties } from "react"
import type { ChartDimension } from "./types"

/** Compact "no chrome" charts for inline contexts (table cells, KPI cards).
 *  No axes, no legend, no grid — just the trend line / bars / area. */
export interface SparklineProps {
  values: number[]
  color?: string
  /** Render straight lines instead of curved. */
  straight?: boolean
  className?: string
  style?: CSSProperties
  height?: ChartDimension
  width?: ChartDimension
}

function toRows(values: number[]) { return values.map((v, i) => ({ i, v })) }

export function SparkLine({ values, color = "#3b82f6", straight, className, style, height = 40, width = "100%" }: SparklineProps) {
  return (
    <ResponsiveContainer width={width} height={height} className={className} style={style}>
      <LineChart data={toRows(values)} margin={{ top: 2, right: 2, left: 2, bottom: 2 }}>
        <Line type={straight ? "linear" : "monotone"} dataKey="v" stroke={color} strokeWidth={2} dot={false} isAnimationActive={false} />
      </LineChart>
    </ResponsiveContainer>
  )
}

export function SparkBar({ values, color = "#3b82f6", className, style, height = 40, width = "100%" }: SparklineProps) {
  return (
    <ResponsiveContainer width={width} height={height} className={className} style={style}>
      <BarChart data={toRows(values)} margin={{ top: 2, right: 2, left: 2, bottom: 2 }}>
        <Bar dataKey="v" fill={color} radius={[2, 2, 0, 0]} isAnimationActive={false} />
      </BarChart>
    </ResponsiveContainer>
  )
}

export function SparkArea({ values, color = "#3b82f6", straight, className, style, height = 40, width = "100%" }: SparklineProps) {
  return (
    <ResponsiveContainer width={width} height={height} className={className} style={style}>
      <AreaChart data={toRows(values)} margin={{ top: 2, right: 2, left: 2, bottom: 2 }}>
        <Area type={straight ? "linear" : "monotone"} dataKey="v" stroke={color} fill={color} fillOpacity={0.3} isAnimationActive={false} />
      </AreaChart>
    </ResponsiveContainer>
  )
}
